module.exports = __webpack_public_path__ + "a818f020a253ca93fc4a48583f758958.jpg";